/**
 * The activity's own "Max Redemptions" cap (products.redemption_qty), counted across every pass
 * and passholder. `products.redemptions_remaining` is the derived counter the backend recomputes on
 * every redemption, and it is null when the activity is uncapped.
 *
 * Lives here rather than in the Tickets module helpers because the products store needs it too, and
 * stores must not import from components.
 */
// eslint-disable-next-line import/prefer-default-export
export function hasProductRedemptionsRemaining(product) {
  const remaining = product?.redemptions_remaining;
  return remaining === null || remaining === undefined || Number(remaining) > 0;
}
